<div>
  <mat-checkbox [checked]="eventShapesVisibilitySignal()" (change)="updateEventTypeShapes($event.checked)">
    Show Event Types
  </mat-checkbox>
</div>

<mat-list>
  @for (shape of (shapes$ | async) ?? [] | sort: ['code']; track shape.code) {
    <mat-list-item>
      <div class="list-item-container">
        <span matListItemTitle>{{ shape.code }} - {{ shape.description | titlecase }}</span>
        <div class="list-item-container">
          @if (shape.managementOfChangeId) {
            <mat-chip-set>
              <mat-chip class="historical-tag">Historical</mat-chip>
            </mat-chip-set>
          }
          <svg class="shape-container">
            <use
              [attr.xlink:href]="'assets/icons/event-shapes.svg#' + concatShapes(shape.shapeType)"
              [attr.fill]="shape.colour"
            ></use>
          </svg>
        </div>
      </div>
      <div class="divider">
        <mat-divider />
      </div>
    </mat-list-item>
  }
</mat-list>
